import { useEffect } from 'react'
import { logoutAction, useAppDispatch, useAppSelector } from '@/store'
import { useAuth } from '@/contexts/AuthContext'
import { fetchFolderTree } from '@/store/slices/foldersSlice'
import { fetchFolderFiles } from '@/store/slices/filesSlice'
import { useRecentlyViewed } from '@/hooks/useRecentlyViewed'

export default function ReduxDataLoader() {
  const dispatch = useAppDispatch()
  const { isAuthenticated } = useAuth()
  const initialized = useAppSelector((state) => state.folders.initialized)
  const isLoadingTree = useAppSelector((state) => state.folders.isLoading)
  const { refresh: refreshRecentlyViewed } = useRecentlyViewed()

  useEffect(() => {
    if (isAuthenticated) {
      if (!initialized && !isLoadingTree) {
        dispatch(fetchFolderTree())
        dispatch(fetchFolderFiles(null))
        refreshRecentlyViewed()
      }
    } else {
      dispatch(logoutAction())
    }
  }, [isAuthenticated, dispatch, initialized, isLoadingTree, refreshRecentlyViewed])

  return null
}
